module.exports = __webpack_public_path__ + "static/media/rt-bus-route-default.de47ea37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/markers/rt-bus-route-default.svg
// module id = 300
// module chunks = 0